import React, { Component } from 'react';
import { Form, Table, Modal, Button, Popconfirm, message } from 'antd';
import { getConfigList, getConfigDel } from '../../../apis/api'

import SystemEdit from './systemEdit';

class systemList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      listData: [],
      loading: false,
      isSystem: '',
      recordList: {},
      pagination: {
        total: 0,
        current: 1,
        pageSize: 10,
        onChange: this.handlePageChange,
      },
    }
  }

  componentWillMount() {}

  componentDidMount(){
    this.getList()
  }

  componentWillUnmount() {
    // 在卸载的时候对所有的操作进行清除
    this.setState = (state, callback) => {
      return;
    };
  }

  getList = () => {
    const { pagination } = this.state;

    this.setState({
      loading: true
    })

    getConfigList({ 
      access_token: sessionStorage.getItem('access_token'),
      page: pagination.current,
      page_size: pagination.pageSize
    }).then(res => {
      
      if(res.code === 0) {
        this.setState({
          loading: false,
          listData: res.content || [],
        })
      } else {
        this.setState({
          listData: [],
          loading: false
        })
      }
    }).catch(err => {
      this.setState({
        loading: false
      })
    })
  }

  // 页码改变
  handlePageChange = (page, pageSize) => {
    const { pagination } = this.state;
    this.setState({
      pagination: Object.assign(pagination, {
        current: page
      })
    }, () => {
      this.getList()
    })
  }

  // 每页条数改变
  handlePagesizeChange = (page, pageSize) => {
    const { pagination } = this.state;
    this.setState({
      pagination:{
        ...pagination,
        current: 1, 
        pageSize,
      }
    },() =>{
      this.getList();
    })
  }

  // 删除
  onDelete = (e) => {

    getConfigDel({ 
      access_token: sessionStorage.getItem('access_token'),
      id: e.id 
    }).then(res => {
      
      if(res.code === 0) {
        message.success('删除成功');
        this.getList()
      } else {
        message.error(res.message);
      }
    })

  }

  render() {
    const { visible } = this.props;
    const { loading, listData, pagination, isSystem, recordList } = this.state;
    const columns = [
      {
        title: '序号',
        dataIndex: 'id',
        width:'60px',
        align:'center',
        render: text => <span>{text}</span>,
      }, {
        title: '系统名称',
        dataIndex: 'name',
        width:'120px',
        align:'center',
        render: text => <span>{text}</span>,
      }, {
        title: '模型名称',
        dataIndex: 'model',
        width:'120px',
        align:'center',
        render: text => <span>{text}</span>,
      }, {
        title: '操作',
        dataIndex: 'operate',
        align: 'center',
        fixed: 'right',
        width: 120,
        render: (text,record) =>{
          return (
            <div>
              <a onClick={()=>{ this.setState({ isSystem: true, recordList: record }) }}>编辑</a>
              <Popconfirm
                title="确认删除此应用系统?"
                onConfirm={() => this.onDelete(record)}
                okText="确认"
                cancelText="取消"
              >
                <a style={{margin:'0 10px'}}>删除</a>
              </Popconfirm>
            </div>
          )
        }
      }
    ]
    const tableConfig = {
      loading: loading,
      columns: columns,
      pagination,
      dataSource: listData
    }
    return (
      <Modal 
        className="systemModal"
        title="应用系统"
        visible={visible} 
        destroyOnClose = {true}
        width={1000}
        footer={[]}
        onCancel={this.props.handleCancel}
      >
        <div className="layout_content_wrapper">
          <Button
            type="primary"  
            onClick={()=>{
              this.setState({
                isSystem: true
              })
            }}
          >添加</Button>
          <div className='layout_content_table'>
            <Table
              rowKey={(record, index) => index}
              {...tableConfig}
            />
          </div>
        </div>

        {
          isSystem ? 
            <SystemEdit 
              visible={isSystem}
              recordList={recordList}
              doSearch={this.getList}
              handleCancel={() => {
                this.setState({ isSystem: false, recordList: {} })
              }} 
            /> : ''
        }
      </Modal>
      
    );
  }
}

const systemListForm = Form.create()(systemList);
export default systemListForm;


// WEBPACK FOOTER //
// ./src/page/LogManagement/components/systemList.js